<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
    </div>

    <form @submit.prevent="store('')" class="form-content">
        <div class="form-content-inner">

            <div class="form-col">
                <field :label="$t('Decree No.')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                    <control type="text" v-model="contract.decree_no"/>
                </field>
            </div>
            <div class="form-col">
                <field :label="$t('Decree Date')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                    <datepicker v-model="contract.decree_date" :enableTimePicker="false" name="decree_date" :auto-apply="true"></datepicker>
                </field>
            </div>
            <div class="form-col">
                <field :label="$t('Period End Date')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                    <datepicker v-model="contract.period_end_date" :enableTimePicker="false" name="period_end_date" :auto-apply="true"></datepicker>
                </field>
            </div>

            <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
                <jb-buttons class="buttons-action-submit">
                    <jb-button type="submit" color="info" :icon="mdiCheckBold" :label="$t('finance.button.btnSubmit')" class="form-submit-btn" />
                    <jb-button type="button" color="info" outline :label="$t('finance.button.btnReset')" class="form-noicon-btn btn-reset" @click="reset()" />
                </jb-buttons>
            </div>
        </div>
    </form>
</template>
<script>
/* eslint-disable */
import { ref, reactive, onMounted, onBeforeMount, watch, watchEffect } from 'vue'
import axios from 'axios'
import { axiosDocument } from "@/boot/axios";
import { mdiBallot, mdiCheckBold, mdiClose } from '@mdi/js'
import { useStore } from 'vuex'
import Control from '@/components/Control'
import { useRouter } from 'vue-router'
import JbButton from '@/components/JbButton'
import JbButtons from '@/components/JbButtons'
import Field from '@/components/Field'
import { useToast } from 'vue-toastification'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main\.css'
import Loading from 'vue-loading-overlay'
export default {
    name: 'ClassForm',
    components: {
        Field,
        Datepicker,
        Control,
        JbButton,
        JbButtons,
        Loading
    },
    props: {
        showEdit: { Boolean },
        propClass: {
            type: Object,
            default: () => ({ empty: true })
        },
        propObject: {
            type: Object,
            default: () => ({ empty: true })
        }
    },
    data: function () {
        return {
        }
    },
    emits: ['close-modal', 'is-new', 'submit', 'refresh-list'],
    setup (props, { emit }) {
        const titleStack = ref(['Admin', 'Forms'])
        const isLoading = ref(false)
        const toast = useToast()
        const router = useRouter()

        const errors = ref([])

        const str = useStore()
        const userlogin = localStorage.getItem('name')

        const contract = reactive({
            id: '',
            employee_id: '',
            decree_no: '',
            decree_date: '',
            period_end_date: '',
            created_by: '',
            updated_by: ''
        })

        const store = async (env) => {
            isLoading.value = true
            const url = props.showEdit ? 'employeecontract/' + contract.id : 'employeecontract';
            const method = props.showEdit ? "PUT" : "POST";

            contract.created_by = userlogin
            console.log('contract', contract)

            const jsonData = JSON.stringify(contract)

            const configHeaders = {
                "content-type": "application/json",
                "Accept": "application/json"
            };

            await axios({
                    method,
                    url,
                    data: jsonData,
                    headers: configHeaders
                })
                .then(response => {
                    if (response.data.success) {
                        isLoading.value = false
                        emit('close-modal')
                        emit('refresh-list')
                        toast.success(response.data.message)
                    } else {
                        isLoading.value = false
                        errors.value = response.data.message
                        toast.error(response.data.message)
                    }
                })
                .catch(error => {
                    isLoading.value = false
                    console.log(error)
                })
        }

        onBeforeMount(() => {
        })

        onMounted(() => {
            // contract.value =toRefs(props, 'propClass')
        })

        watchEffect(() => {
            const newobject = props.propObject;
            Object.assign(contract, newobject);

            if (!props.showEdit) {
                contract.id = null;
                contract.decree_no = null;
                contract.decree_date = null;
                contract.period_end_date = null;
            }

            const newcontract = props.propClass
            contract.submenu = newcontract.submenu
            contract.ein = newcontract.ein
            contract.employee_id = newcontract.employee_id
            contract.nickname = newcontract.nickname
        })
        
        return {
            titleStack,
            mdiBallot,
            mdiCheckBold,
            mdiClose,
            router,
            contract,
            store,
            toast,
            userlogin,
            errors,
            isLoading
        }
    },
    methods: {
    }
}
</script>
